var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Row } from "react-bootstrap";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
var Platforms = function (props) {
    var _a = __read(React.useState(), 2), platFormData = _a[0], setplatFormData = _a[1];
    var PlatformColumn = [
        {
            columnName: "MILESTONE",
            key: "milestone",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "WEBSITE",
            key: "website",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "EMT (MOBILE APP)",
            key: "mobileapp",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "TX3",
            key: "tx3",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
    ];
    var PlatformRows = [
        {
            milestone: "Preferred Platform",
            website: "-",
            mobileapp: "-",
            tx3: "-",
        },
        {
            milestone: "Last Login Date",
            website: platFormData === null || platFormData === void 0 ? void 0 : platFormData.web_LL_Date,
            mobileapp: platFormData === null || platFormData === void 0 ? void 0 : platFormData.emT_LL_Date,
            tx3: platFormData === null || platFormData === void 0 ? void 0 : platFormData.tX3_LL_Date,
        },
        {
            milestone: "Last Trade Date",
            website: platFormData === null || platFormData === void 0 ? void 0 : platFormData.web_LT_Date,
            mobileapp: platFormData === null || platFormData === void 0 ? void 0 : platFormData.emT_LT_Date,
            tx3: platFormData === null || platFormData === void 0 ? void 0 : platFormData.tX3_LT_Date,
        },
        {
            milestone: "1st Trade Date",
            website: platFormData === null || platFormData === void 0 ? void 0 : platFormData.web_FT_Date,
            mobileapp: platFormData === null || platFormData === void 0 ? void 0 : platFormData.emT_FT_Date,
            tx3: platFormData === null || platFormData === void 0 ? void 0 : platFormData.tX3_FT_Date,
        },
        {
            milestone: "1st Login Date",
            website: platFormData === null || platFormData === void 0 ? void 0 : platFormData.web_FL_Date,
            mobileapp: platFormData === null || platFormData === void 0 ? void 0 : platFormData.emT_FL_Date,
            tx3: platFormData === null || platFormData === void 0 ? void 0 : platFormData.tX3_FL_Date,
        },
        {
            milestone: "Demo Date",
            website: platFormData === null || platFormData === void 0 ? void 0 : platFormData.web_Demo_Date,
            mobileapp: platFormData === null || platFormData === void 0 ? void 0 : platFormData.emT_Demo_Date,
            tx3: platFormData === null || platFormData === void 0 ? void 0 : platFormData.tX3_Demo_Date,
        },
    ];
    React.useEffect(function () {
        setplatFormData(props.data);
    }, [props.data]);
    return (React.createElement("section", { className: "section-padding" },
        React.createElement(Row, { className: "relationship-head-block mx-0 px-0 platform-head-block" },
            React.createElement("div", { className: "DMSanBold_18_700 txt_blackOne1 ps-0" }, "Platforms")),
        React.createElement(GenericTable, { columns: PlatformColumn, data: PlatformRows, parentClassName: "salestableParentClass", tableClassName: "salestableclass" })));
};
export default Platforms;
